<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item to="/home" @click="updateListCategory('listCategoryHome')">Home</b-breadcrumb-item>
      <b-breadcrumb-item to="/collaborativeList" @click="updateListCategory('collaborativeList')">Collaborative List
      </b-breadcrumb-item>
      <b-breadcrumb-item
          v-if="toDoListDetails.toDoListId"
          :to="{ name: 'Collaborative Task List', params: { collaborativeListId: toDoListDetails.toDoListId }}"
          @click="updateListCategory('collaborativeTaskList')">
        {{ toDoListDetails.toDoListName }}
      </b-breadcrumb-item>
      <b-breadcrumb-item
          v-if="toDoListDetails.toDoListId"
          :to="{ name: 'View Collaborators', params: { collaborativeListId: toDoListDetails.toDoListId }}"
          @click="updateListCategory('viewCollaborators')">View Collaborators
      </b-breadcrumb-item>
      <b-breadcrumb-item href="#collaboratorDetails" active>Collaborator Details</b-breadcrumb-item>
    </b-breadcrumb>
    <h1 class="template-name">Collaborator Details</h1>
    <p>View the collaborator's details.</p>
    <hr>
    <collaborator-list-cell :user-details="collaboratorInformation"></collaborator-list-cell>
    <h2 class="section-title">Collaborator's Task Distribution</h2>
    <div class="task-container">
      <div class="no-task-container" v-if="collaboratorTaskDocuments.length === 0">
        <b-img class="no-task-picture" :src="require('../../assets/no_task.png')"
               alt="No task picture"></b-img>
        <h2>No task assigned</h2>
        <p>The collaborator currently has no assigned task</p>
      </div>
      <regular-with-assignee-task-cell v-for="collaboratorTask in collaboratorTaskDocuments"
                                       :key="collaboratorTask.taskId"
                                       :task-details="collaboratorTask"></regular-with-assignee-task-cell>
    </div>
  </div>
</template>

<script>
  import CollaboratorListCell from "../table_cells/collaborator_cell/CollaboratorListCell"
  import RegularWithAssigneeTaskCell from "../table_cells/task_cells/RegularWithAssigneeTaskCell"
  import {mapActions, mapGetters} from "vuex";
  import {db} from "../../main";
  import router from "../../router";

  export default {
    name: "CollaboratorDetails.vue",
    components: {
      collaboratorListCell: CollaboratorListCell,
      regularWithAssigneeTaskCell: RegularWithAssigneeTaskCell
    },
    data() {
      return {
        toDoListId: null,
        toDoListDetails: {},
        collaboratorId: null,
        collaboratorInformation: {},
        collaboratorTaskDocuments: []
      }
    },
    methods: {
      ...mapActions([
        "updateListCategory"
      ]),
      getCurrentUserRole() {
        // retrieve the current user administrative privilege to modify other collaborator's task
        db.collectionGroup('user_collaborative_to_do_list_participation')
          .where('collaborativeToDoListId', '==', this.toDoListId)
          .where('collaboratorId', '==', this.$store.getters.user.data.id)
          .get()
          .then(querySnapshot => {
            const userCollaborativeToDoListParticipatedObject = querySnapshot.docs.map(doc => doc.data())
            this.$store.dispatch('setIsCollaborativeListAdministrator', userCollaborativeToDoListParticipatedObject[0].collaborativeToDoListRole === 'Administrator')
          })
      },
      getCollaboratorInformation() {
        // retrieve the collaborator information
        db
          .collection('users/' + this.collaboratorId + '/user_collaborative_to_do_list_participation')
          .where('collaborativeToDoListId', '==', this.toDoListId)
          .onSnapshot(querySnapshot => {
            const userCollaborativeToDoListParticipatedObject = querySnapshot.docs.map(doc => doc.data())
            this.collaboratorInformation = userCollaborativeToDoListParticipatedObject[0]

            this.$store.dispatch("setIsCollaborativeListOwner", this.collaboratorInformation.owner)
          })
      },
      getCollaboratorTask() {
        this.$bind(
          'collaboratorTaskDocuments',
          db
            .collection('collaborative_to_do_lists/' + this.toDoListId + '/tasks')
            .where('assigneeId', '==', this.collaboratorId)
            .orderBy('taskName', 'asc')
        )
      }
    },
    mounted() {
      this.toDoListId = this.$route.params.collaborativeListId
      this.collaboratorId = this.$route.params.collaboratorId

      db.collection('collaborative_to_do_lists')
        .doc(this.toDoListId)
        .onSnapshot(doc => {
          this.toDoListDetails = doc.data()
        })

      this.getCurrentUserRole()
      this.getCollaboratorInformation()
      this.getCollaboratorTask()
    },
    destroyed() {
      this.$store.dispatch("setIsCollaborativeListOwner", false)
    }
  }
</script>

<style scoped>
  .no-task-container {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .no-task-picture {
    width: 375px;
    margin-bottom: 1em;
  }

  .template-name {
    font-size: 2em;
    margin-bottom: 0.5em;
  }

  .task-container {
    height: 52vh;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
  }

  .section-title {
    font-size: 1.5em;
    margin-bottom: 0.5em;
  }
</style>
